import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createCustomerAccount = async (values, callback) => {
    console.log("Values : ", values);
    const res = await axios.post(`/customeraccount/customeraccount`, values);
    callback(res.data.response);
}

export const updateCustomerAccount = async (id, values, callback) => {
    const res = await axios.put(`/customeraccount/updatecustomeraccount/${id}`, values);
    callback(res.data.response);
}

export const deleteCustomerAccount = async (id, callback) => {
    const res = await axios.delete(`/customeraccount/deletecustomeraccount/${id}`);
    callback(res.data.response)
}

export const getCustomerAccountsByDateRange = async (startDate, endDate, rowPerPage, pageNumber, callback) => {
    const res = await axios.get(`/customeraccount/${startDate}&${endDate}?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}`);
    callback(res.data.response)
}

export const getCustomerAccounts = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/customeraccount/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);
    callback(res.data.response)
}

export const getCustomerAccountById = async (id, callback) => {
    const res = await axios.get(`/customeraccount/${id}`);
    callback(res.data.response)
}

export const CusAccountAPI = () => {
    const [customerAccounts, setCustomerAccounts] = useState([]);
    const [customerAccountDetail, setCustomerAccountDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [customerId, setCustomerId] = useState(0);

    useEffect(() => {
        getCustomerAccounts(rowPerPage, pageNumber, search, res => {
            setCustomerAccounts(res);
            setTotalPages(res.totalPages || 1);
        })

        getCustomerAccountById(customerId, res => {
            setCustomerAccountDetail(res.data);
        })
    }, [callback, rowPerPage, search, pageNumber, customerId])

    return {
        customerAccounts: [customerAccounts, setCustomerAccounts],
        customerAccountDetail: [customerAccountDetail, setCustomerAccountDetail],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback],
        customerId: [customerId, setCustomerId]
    }
}